'use client';

import React, { Suspense } from 'react';
import DiscoverContent from './components/DiscoverContent';
import TopSearchBar from '@/components/TopSearchBar';
import BottomNav from '@/components/BottomNav';

export default function DiscoverPage() {
  return (
    <div className="min-h-screen" style={{ background: 'var(--background)' }}>
      <TopSearchBar />
      <Suspense fallback={null}>
        <DiscoverContent />
      </Suspense>
      <BottomNav />
    </div>
  );
}
